import React, { useEffect } from "react";
import "./../Usuarios/usuarios.css";

import { SubSections } from "../../data/navItem";
import NotificacionesDashboard from "./NotificacionesDashboard";
import NotificacionesCatalogo from "./NotificacionesCatalogo";

export default function Notificaciones({ subSectionId }) {
  const fetchData = async () => {};

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {subSectionId === SubSections.Asociados && <NotificacionesDashboard />}
      {subSectionId === SubSections.OrdenesVenta && <NotificacionesCatalogo />}
    </>
  );
}
